/**
 * @desc 详情
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<defs.tms.CustomsDeclarationMasterResponseDto>;
export function request(id: string | number, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/customsDeclarationMaster/getDetail/${id}`, {
      method: "GET",

      ...options,
    }),
  );
}
